<template>
    <div class="homePrice" id="price">
        <div class="price-table">
            <div class="price-content-left">
                <div class="content-left-title">
                    <span class="title-detail">公有云</span>
                </div>
                <div class="content-left-ctx">
                    <ul>
                        <li class="type-trail">&nbsp;</li>
                        <li>针对用户</li>
                        <li>全功能开放</li>
                        <li>使用周期</li>
                        <li>空间容量</li>
                        <li>大文件上传</li>
                    </ul>
                    <ul>
                        <li class="type-trail">
                            <img class="imgone" :src="`${$baseUrl}dataMock/homePage/type-trail.png`" />
                        </li>
                        <li>个人用户</li>
                        <li>
                            <img class="imgone" :src="`${$baseUrl}dataMock/homePage/block.png`" />
                        </li>
                        <li style="color: #ffaa3e;">免费3个月</li>
                        <li>1G</li>
                        <li>&le;500MB</li>
                    </ul>
                    <ul>
                        <li class="type-trail">
                            <img class="imgone" :src="`${$baseUrl}dataMock/homePage/type-pro.png`" />
                        </li>
                        <li>企业用户</li>
                        <li>
                            <img class="imgone" :src="`${$baseUrl}dataMock/homePage/block.png`" />
                        </li>
                        <li>按年收费</li>
                        <li>10G</li>
                        <li>无限制</li>
                    </ul>
                </div>
            </div>
            <div class="price-content-right">
                <div class="content-right-title">
                    <span class="title-detail">私有云</span>
                </div>
                <div class="content-right-ctx">
                    <div class="ctx-detail">
                        <span>希望布置私有云的企业</span>
                        <span>可分模块收费</span>
                        <span>1对1技术服务</span>
                    </div>
                    <div class="ctx-detail" style="margin-top: 5%;">
                        <span>想了解更多云平台服务</span>
                        <span>请联系我们（微信同号）：</span>
                        <span>189-1614-5929 吴经理</span>
                    </div>
                    <div class="ctx-detail" style="margin-top: 5%;">
<!--                        <span>QQ群：</span>
                        <span>874671773</span>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="price-btn">
            <!--<button class="contact-btn" @click.prevent="contactUs">开通商业版</button>-->
            <button class="contact-btn" @click="indexUserLogin">立即注册</button>
        </div>
        <!--        <el-dialog :visible.sync="priceDialog" width="800px">-->
        <!--            <div class="contactUs-content">-->
        <!--                <span class="contactUs-title">-->
        <!--                    联系方式-->
        <!--                </span>-->
        <!--                <div class="contactUs-detail">-->
        <!--                    <div class="detail-info">-->
        <!--                        <img class="imgone" :src="`${$baseUrl}dataMock/homePage/mobile.png`" />-->
        <!--                        <div class="info-item">-->
        <!--                            <span class="item-list title">电话</span>-->
        <!--                            <span class="item-list">010-64518294（董工）</span>-->
        <!--                            <span class="item-list">010-64518228（李工）</span>-->
        <!--                        </div>-->
        <!--                        <img class="imgone" :src="`${$baseUrl}dataMock/homePage/email.png`" />-->
        <!--                        <div class="info-item">-->
        <!--                            <span class="item-list title">Email：</span>-->
        <!--                            <span class="item-list">cloud@pkpm.com.cn</span>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash; <div class="img-wrapper">-->
        <!--              <img class="imgone" :src="`${$baseUrl}dataMock/homePage/QRCode.png`"/>-->
        <!--            </div> &ndash;&gt;-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </el-dialog>-->
    </div>
</template>

<script>
import { userLogin } from 'src/utils/loginUtils';
export default {
    name: 'homePrice',
    components: {},
    data() {
        return {
            priceDialog: false,
        };
    },
    computed: {},
    methods: {
        contactUs() {
            this.priceDialog = true;
        },
        indexUserLogin() {
            userLogin();
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.homePrice
  width 100%
  height 900px
  margin-bottom 50px
  background-color #F5F5F5
  dom_center()
  flex-direction column
  .price-table
    width 100%
    dom_center()
    .price-content-left
      width 34%
      min-width 650px
      dom_center()
      flex-direction column
      .content-left-title
        width 100%
        height 60px
        dom_center()
        background-color #DDDDDD
        .title-detail
          font-size 24px
          color #999999
          line-height 30px
      .content-left-ctx
        width 100%
        dom_center()
        ul
          width 33.33%
          dom_center()
          flex-direction column
          li
            dom_center()
            width 100%
            height 94px
            font-size 22px
            color #333333
            font-weight bold
            box-sizing border-box
            border-bottom 1px solid #DDDDDD
        ul:nth-child(1)
          li
            dom_center()
            justify-content flex-start
            padding-left 30%
            width 100%
            height 94px
            font-size 22px
            color #333333
            font-weight normal
            box-sizing border-box
            border-left 1px solid #DDDDDD
            border-bottom 1px solid #DDDDDD
        .type-trail
          display flex
          align-items center
          justify-content center
          height 110px !important
          img
            max-width 140px
            max-height 50px
            width 100%
            height 100%
    .price-content-right
      width 19%
      min-width 346px
      dom_center()
      flex-direction column
      .content-right-title
        width 100%
        height 60px
        dom_center()
        background-color #DDDDDD
        .title-detail
          font-size 24px
          color #999999
          line-height 30px
      .content-right-title
        width 100%
        dom_center()
      .content-right-ctx
        height 580px
        display flex
        align-items flex-start
        justify-content center
        flex-direction column
        width 100%
        box-sizing border-box
        border-left 1px solid #DDDDDD
        border-right 1px solid #DDDDDD
        border-bottom 1px solid #DDDDDD
        .ctx-detail
          width 100%
          dom_center()
          justify-content center
          flex-direction column
          align-items flex-start
          span
            font-size 22px
            color #333333
            padding 3% 0px 3% 5px
            margin-left 15%
  .price-btn
    width 100%
    dom_center()
    .contact-btn
      margin-top 20px
      width 220px
      height 80px
      background #1B8CF4
      border-radius 40px
      border 0px
      font-size 22px
      font-weight bold
      line-height 20px
      outline none
      &:hover
        background #1BA8F4
  .contactUs-content
    dom_center()
    flex-direction column
    .contactUs-title
      width 100%
      dom_center()
      font-size 24px
      color #333333
      font-weight bold
    .contactUs-detail
      width 100%
      dom_center()
      .detail-info
        width 300px
        height 220px
        display flex
        justify-content center
        align-items center
        flex-direction row
        flex-wrap wrap
        .info-item
          width 210px
          dom_center()
          align-items flex-start
          flex-direction column
          .item-list.title
            font-weight normal
            color #666666
          .item-list
            padding 10px 0px 2px 20px
            font-weight bold
            font-size 18px
            color #0C78E2
        .imgone
          height 66px
          width 66px
    .img-wrapper
      display flex
      align-items center
      justify-content center
      padding-left 30px
      .imgone
        max-width 240px
        max-height 240px
        width 100%
        height 100%
</style>



// WEBPACK FOOTER //
// src/pages/index/home-price.vue